import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	style: { isolation: "isolate" },
	viewBox: "1321.351 77.124 19.413 19.413",
	width: "19.413pt",
	height: "19.413pt",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("line", {
		x1: 1322.057,
		y1: 77.83,
		x2: 1340.057,
		y2: 95.83,
		vectorEffect: "non-scaling-stroke",
		strokeWidth: 1,
		stroke: "rgb(51,51,51)",
		strokeLinejoin: "miter",
		strokeLinecap: "square",
		strokeMiterlimit: 3
	}), /* @__PURE__ */ _jsx("line", {
		x1: 1340.057,
		y1: 77.83,
		x2: 1322.057,
		y2: 95.83,
		vectorEffect: "non-scaling-stroke",
		strokeWidth: 1,
		stroke: "rgb(51,51,51)",
		strokeLinejoin: "miter",
		strokeLinecap: "square",
		strokeMiterlimit: 3
	})] })
});
export default SvgIcClose;
